import React, { Fragment, useEffect, useState } from "react";
import {Link, useNavigate} from "react-router-dom";
import { useLoadingStore } from "@/stores/loading";
import { useUserStore } from "@/stores/user";
import { login } from "@/api/login";
import { useMessageModalStore } from "@/stores/message";
import * as Config from "@/config";
import { title } from "process";
import { LoginInformation, getLoginInformation } from "@/api/information";

export default function Login() {
  const navigate = useNavigate();
  const setLoading = useLoadingStore((state) => state.setLoading);
  const setUser = useUserStore((state) => state.setUser);
  const setMessage = useMessageModalStore((state) => state.setMessage);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [hide, setHide] = useState(true);

  const onClickEye = () => {
    setHide(!hide);
  };

  const onClickLogin = () => {
    setLoading(true);
    login({
      login_id: email,
      password,
    })
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          setUser(res.data.result);
          navigate("/drm_pf/api");
        } else {
          setMessage(res.data.error ?? Config.MESSAGE_NO_P11);
        }
      })
      .catch((error) => {
        setMessage(Config.MESSAGE_NO_P11);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [information, setInformation] = useState<LoginInformation>();
  useEffect(() => {
    setLoading(true);
    getLoginInformation()
      .then((res) => {
        setInformation(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const infoLoading = information === undefined;
  const infoExists =
    information?.information_list && information?.information_list.length > 0;

  return (
    <div className="login-container uk-width-1-1">
      <div className="login-item login-item-information">
        <div className="login-item-header">
          <p>お知らせ</p>
        </div>
        <div className="login-item-body login-item-body-information">
          {infoExists
            ? information?.information_list?.map((information) => (
                <section key={information.id}>
                  <p className="section-header">
                    <strong>{information.title}</strong>
                  </p>
                  <p className="section-body">{information.details}</p>
                </section>
              ))
            : !infoLoading && <>お知らせはありません</>}
        </div>
      </div>
      <div className="login-item">
        <div className="login-item-header">
          <p>ログイン</p>
        </div>
        <div className="login-item-body login-item-body-login">
          <div className="message">
            マイページを利用するには、ログインID、パスワードを入力の上、「ログイン」ボタンをクリックしてください。
          </div>
          <div className="mailadress">
            <p>ログインID</p>
            <div>
              <input
                className="uk-input uk-form-small mailadress-form"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div>ログインIDを忘れた方は<Link to="/forgot_login_id">こちら</Link></div>
            </div>
          </div>
          <div className="password">
            <p>パスワード</p>
            <div className="uk-inline">
              <input
                id="textPassword"
                className="uk-input uk-form-small password-form"
                type={hide ? "password" : "text"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                id="buttonEye"
                className={
                  hide
                    ? "uk-form-icon uk-form-icon-flip fa fa-eye"
                    : "uk-form-icon uk-form-icon-flip fa fa-eye-slash"
                }
                onClick={onClickEye}
              ></button>
              <div>パスワードを忘れた方は<Link to="/forgot_password">こちら</Link></div>
            </div>
          </div>
          <div className="uk-flex uk-flex-center uk-margin-small-top">
            <button
              onClick={onClickLogin}
              className="uk-button--l uk-button-refer"
            >
              ログイン
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
